module.exports = __webpack_public_path__ + "img/logo_roxo.e744f7d9.png";